export default {
  // Navigation
  'nav.home': 'Ana Sayfa',
  'nav.play': 'Nasıl Çalışır',
  'nav.store': 'Ödüller',
  'nav.teamBuilding': 'Takımlar İçin',
  'nav.events': 'Etkinlikler',
  'nav.business': 'İşletmeler İçin',
  'nav.about': 'Hakkımızda',
  'nav.contact': 'İletişim',
  'nav.startPlaying': 'Oynamaya Başla',

  // Home Section
  'home.badge': 'Dijital Şehir Rehberi · Etkinlik Pazarı',
  'home.title1': 'Dijital Şehir Rehberin.',
  'home.slogan': 'Şehirleri Oyun Alanına Çevir.',
  'home.heroDesc': 'CitySeek şehrinde neler olduğunu gösterir ve keşfetmeyi bir oyuna dönüştürür. Etkinlikleri bul, gerçek mekanları yürüyerek keşfet ve yol boyunca ödüller topla.',
  'home.startAdventure': 'Oynamaya Başla',
  'home.watchVideo': 'Videoyu İzle',
  'home.feature1': 'Yürüyerek Keşfet',
  'home.featureEvents': 'Etkinlik Bul',
  'home.feature2': 'Konum Doğrula',
  'home.feature3': 'Coin & Puan Kazan',
  'home.feature4': 'Oyuncularla Sohbet',
  'home.feature5': 'Sıralamada Yüksel',
  'home.feature6': 'Yerel Dükkanlarda Harca',
  'home.instantPlay': 'Doğrudan tarayıcıda çalışır. Uygulama mağazası yok, indirme yok.',

  // Video Section
  'video.title': 'CitySeek\'i İzle',
  'video.subtitle': 'İnsanlar Darmstadt\'ı şu anda nasıl keşfediyor, izle.',
  'video.cta': 'Kendi şehrinde dene',

  // Event Marketplace
  'marketplace.eyebrow': 'Yeni · Etkinlik Pazarı',
  'marketplace.title': 'Şehrinin Etkinlik Pazarı',
  'marketplace.subtitle': 'Yakınında neler olduğunu gör, ardındaki mekanları ve sanatçıları tanı. Şehrinin sunduğu her şey tek bir yerde.',
  'marketplace.filterNearby': 'Yakında',
  'marketplace.filterTrending': 'Popüler',
  'marketplace.filterWeek': 'Bu Hafta',
  'marketplace.filterAll': 'Tümü',
  'marketplace.events.title': 'Etkinlikler',
  'marketplace.events.desc': 'Yakınındaki konserler, buluşmalar, pazarlar ve pop-up\'lar.',
  'marketplace.venues.title': 'Mekanlar',
  'marketplace.venues.desc': 'Kafeler, barlar, galeriler ve sahneler. Şehrini oluşturan yerleri tanı.',
  'marketplace.artists.title': 'Sanatçılar',
  'marketplace.artists.desc': 'Yerel sanatçıları ve üreticileri takip et, bir daha hiçbir gösteriyi kaçırma.',
  'marketplace.exploreCta': 'Neler Olduğunu Gör',
  'marketplace.partner.badge': 'İşletmeler İçin',
  'marketplace.partner.title': 'Mekanını, etkinliklerini ve sanatçılarını listele',
  'marketplace.partner.subtitle': 'Zaten dışarıda olan yerlilere ulaş. Etkinliklerini yayınla, bir kitle oluştur ve kapından daha çok insan geçsin.',
  'marketplace.partner.point1': 'Etkinliklerini zaten dışarıda olan insanlara göster',
  'marketplace.partner.point2': 'Mekanın ve sanatçıların için bir kitle oluştur',
  'marketplace.partner.point3': 'Erişimini, ilgiyi ve kullanımları gör',
  'marketplace.partner.listCta': 'CitySeek\'te Listele',
  'marketplace.partner.talkCta': 'Bizimle Konuş',

  // How It Works
  'howItWorks.title': 'Nasıl Çalışır',
  'howItWorks.step1.title': 'Şehir & Oyun Seç',
  'howItWorks.step2.title': 'Yürü & Doğrula',
  'howItWorks.step3.title': 'Hikayeleri Keşfet',
  'howItWorks.step4.title': 'Anıları Paylaş',
  'howItWorks.step5.title': 'Ödül Kazan',

  // Game Modes
  'games.title': 'Oyun Kategorilerimiz',
  'games.subtitle': 'Keşfetmenin farklı yolları',
  'games.core.title': 'Ana Oyun',
  'games.core.desc': 'Şehri kendi hızında keşfet, en iyi yerlere sesli ve yazılı kendi rehberinle.',
  'games.weekly.title': 'Timely Challenge',
  'games.weekly.desc': 'Yerel bir mekanda biten, toplanacak ödüllerle dolu sosyal etkinlikler.',
  'games.custom.title': 'Özel Oyunlar',
  'games.custom.desc': 'Takım etkinlikleri, üniversite turları, oryantasyon günleri ve özel gruplar.',

  // Store Section
  'store.title': 'CitySeek Mağaza',
  'store.subtitle': 'Keşfederken coin kazan, sonra yerel kafe, restoran ve mağazalarda harca.',
  'store.step1': 'Coin Topla',
  'store.step1.desc': 'Görevleri tamamla, keşfederken kazan',
  'store.step2': 'Ödüllere Bak',
  'store.step2.desc': 'Yerel ortakların tekliflerini gör',
  'store.step3': 'QR ile Kullan',
  'store.step3.desc': 'Tara ve ortaklarda kullan',
  'store.cta': 'Mağazayı Ziyaret Et',

  // Team Building / İşletmeler İçin
  'team.eyebrow': 'İşletmeler & Takımlar İçin',
  'team.title': 'Takımlar & Markalar İçin Şehir Maceraları',
  'team.subtitle': 'Şirketler, üniversiteler ve organizatörler için özel şehir oyunları. Herkesi toplantı odasından çıkar, birlikte şehre dalın.',
  'team.audience1': 'Şirketler',
  'team.audience2': 'Üniversiteler',
  'team.audience3': 'Tur Operatörleri',
  'team.audience4': 'Markalar & Etkinlikler',
  'team.benefit1': 'Doğal İşbirliği',
  'team.benefit2': 'Aktif Katılım',
  'team.benefit3': 'Yaratıcı Problem Çözme',
  'team.benefit4': 'Yerel Keşif',
  'team.benefit5': 'Daha İyi İletişim',
  'team.benefit6': 'Ölçülebilir Sonuçlar',
  'team.cta1': 'Teklif Alın',
  'team.cta2': 'Demo Planlayın',

  // About Section
  'about.title': 'CitySeek Hakkında',
  'about.subtitle': 'Şehrini deneyimlemenin yeni bir yolu.',
  'about.mission': 'Misyonumuz',
  'about.missionText': 'Şehrini keşfetmenin yeniden heyecan verici hissettirmesini istiyoruz. Bu yüzden gerçek mekanları yapılacak şeylere dönüştürüyor, bu yolda yerel işletmeleri ve şehir kültürünü güçlendiriyoruz.',
  'about.vision': 'Vizyonumuz',
  'about.visionText': 'Her şehrin keşfetmeye değer olduğu bir dünya.',
  'about.values': 'Değerlerimiz',
  'about.value1': 'Otantik Keşif',
  'about.value2': 'Topluluk Öncelikli',
  'about.value3': 'Kaliteli İçerik',
  'about.value4': 'Oyunsu Öğrenme',
  'about.value5': 'Gizlilik & Güvenlik',
  'about.value6': 'Yerlilerden, Yerlilere',
  'about.value7': 'Yerel İşletmeleri Destekleme',
  'about.team': 'Ekip',
  'about.teamSubtitle': 'CitySeek\'in arkasındaki insanlar',
  'about.team.safa': 'Ürünü, ortaklıkları ve CitySeek\'in yönünü yönetir.',
  'about.team.umut': 'CitySeek\'i sorunsuz çalıştıran teknolojiyi kurar.',
  'about.learnMore': 'Daha Fazla',
  'about.getInTouch': 'İletişime Geç',

  // Contact
  'contact.title': 'Merhaba de',
  'contact.subtitle': 'Mekânını ya da etkinliğini eklemek, CitySeek’i şehrine getirmek veya ekibinle bir şey planlamak mı istiyorsun? Bize yaz, seve seve konuşalım.',
  'contact.email': 'E-posta',
  'contact.location': 'Konum',
  'contact.address': 'Hilpertstraße 31, 64295 Darmstadt-West, Almanya',
  'contact.response': 'Yanıt Süresi',
  'contact.responseTime': '24 saat içinde',
  'contact.ctaTitle': 'Keşfetmeye hazır mısın?',
  'contact.ctaSubtitle': 'Şehrini bambaşka bir gözle görenlere katıl.',
  'contact.ctaButton': 'Şimdi Oynamaya Başla',
  'contact.form.getInTouch': 'İletişime Geçin',
  'contact.form.subtitle': 'Ortaklık, sponsorluk ya da takım oyunu? Bize yaz.',
  'contact.form.nameLabel': 'İsim *',
  'contact.form.namePlaceholder': 'Adın',
  'contact.form.emailLabel': 'E-posta *',
  'contact.form.emailPlaceholder': 'sen@sirket.com',
  'contact.form.companyLabel': 'Şirket',
  'contact.form.companyPlaceholder': 'İsteğe bağlı',
  'contact.form.cityLabel': 'Şehir',
  'contact.form.cityPlaceholder': 'İsteğe bağlı',
  'contact.form.useCaseLabel': 'Konu',
  'contact.form.useCaseDefault': 'Bir konu seç',
  'contact.form.useCase.listVenue': 'Mekân ya da etkinlik ekle',
  'contact.form.useCase.artist': 'Sanatçı ya da grup',
  'contact.form.useCase.partnership': 'İş birliği',
  'contact.form.useCase.customGame': 'Özel oyun',
  'contact.form.useCase.teamAdventure': 'Ekip veya grup macerası',
  'contact.form.useCase.press': 'Basın',
  'contact.form.useCase.other': 'Diğer',
  'contact.form.messageLabel': 'Mesaj * (en fazla 500 karakter)',
  'contact.form.messagePlaceholder': 'Nasıl yardımcı olabiliriz?',
  'contact.form.sendButton': 'Mesaj gönder',
  'contact.form.sending': 'Gönderiliyor …',
  'contact.form.successTitle': 'Teşekkürler, mesajını aldık.',
  'contact.form.successMessage': 'En kısa sürede sana döneceğiz.',

  // Footer
  'footer.tagline': 'Dijital şehir rehberin ve etkinlik pazarın. Gerçek maceralar, gerçek ödüller.',
  'footer.product': 'Ürün',
  'footer.howItWorks': 'Nasıl Çalışır',
  'footer.events': 'Etkinlik Pazarı',
  'footer.availableGames': 'Oyun Modları',
  'footer.store': 'Ödül Mağazası',
  'footer.teamBuilding': 'Takımlar İçin',
  'footer.business': 'İşletmeler İçin',
  'footer.company': 'Şirket',
  'footer.about': 'Hakkımızda',
  'footer.contact': 'İletişim',
  'footer.press': 'Basın',
  'footer.legal': 'Yasal',
  'footer.impressum': 'Künye',
  'footer.privacy': 'Gizlilik Politikası',
  'footer.terms': 'Kullanım Koşulları',
  'footer.cookies': 'Çerez Politikası',
  'footer.allRights': 'Tüm hakları saklıdır.',
  'footer.social': 'Bizi Takip Edin',

  // CityLab Pop-Up Widget
  'citylab.widget': 'CityLab Pop-Up',
  'citylab.title': 'CitySeek Pop-Up Darmstadt',
  'citylab.subtitle': 'Etkileşimli galeri ve kültürel merkez',
  'citylab.badge': 'Mart - Mayıs 2026',
  'citylab.visit': 'Ziyaret Et',
  'citylab.location': 'Luisenplatz 5, Darmstadt'
};
